import { createFileRoute } from "@tanstack/react-router"
import { SalesForceAuthModal } from "modules/settings/components/integrations/salesForce/SalesForceAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/salesForce/connect")({
  component: SalesForceAuthModal,
})
